// ** Custom Components
import ListItemAllowAction from "./ListItemAllowAction";
import { AllowedSexDropdown } from "./AllowedSexDropdown";
import Block from "components/layout/Block";

// #####################################################

const AllowedActions = ({ state, dispatch }) => {
	// #####################################################

	return (
		<Block flex column>
			<ListItemAllowAction
				action="Like"
				state={state}
				dispatch={dispatch}
			/>
			<ListItemAllowAction
				action="Comment"
				state={state}
				dispatch={dispatch}
			/>
			<ListItemAllowAction
				action="Invite"
				state={state}
				dispatch={dispatch}
			/>
			<ListItemAllowAction
				action="Following"
				state={state}
				dispatch={dispatch}
			/>
			<AllowedSexDropdown state={state} dispatch={dispatch} />
		</Block>
	);
};

// #####################################################

export default AllowedActions;

// #####################################################
